/* eslint-disable */
export default {
  loading: 'Chargement…',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
